import useLocalize from '../../../utils/hooks/useLocalize';
import SectionHeaderComponent from '../SectionHeaderComponent';
import './SummarySection.scss';
import SymbolMatrix from '../../matrix/SymbolMatrix';


const MatrixSection = ({
  symbol
}) => {
  const localize = useLocalize();
  const title = localize('symbol.details.matrix.section.title');
  return (
    <div className="summary-section">
      <SectionHeaderComponent title={title} />
      <SymbolMatrix
        symbol={symbol}
        enabled={true}
        desktopMode={true}
      />
    </div>
  );
};

export default MatrixSection;
